module.exports = __webpack_public_path__ + "static/media/svg-1.d11196fd.svg";